import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Box,
  Flex,
  Card,
  CardBody,
  Heading,
  Skeleton,
  Spinner,
  VStack,
  Text,
} from "@chakra-ui/react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { TableSpinner } from "../../components/Spinner";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutCharts = ({
  isLoading,
  targetDevices,
  auctionData,
  selectedCountriesImpression,
  countryAuction,
}) => {
  // Country data
  const countryData = {
    labels: selectedCountriesImpression,
    datasets: [
      {
        data: countryAuction,
        backgroundColor: ["#48BB78", "#4299E1", "#ECC94B", "#F56565"],
        borderWidth: 0,
      },
    ],
  };

  // Device data
  const deviceData = {
    labels: targetDevices,
    datasets: [
      {
        data: auctionData,
        backgroundColor: ["#4299E1", "#48BB78", "#ECC94B"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          padding: 20,
          font: {
            size: 14,
          },
        },
      },
    },
    cutout: "50%", // Creates the donut hole
  };

  return (
    <Flex
      justify="center"
      gap={8}
      p={8}
      flexWrap={{ base: "wrap", md: "nowrap" }}
    >
      <Card
        width={{ base: "100%", md: "300px" }}
        boxShadow="lg"
        border="1px solid #ccc"
        borderRadius="4px"
        padding={"8px"}
      >
        <CardBody>
          <Heading
            size="md"
            mb={4}
            textAlign="center"
            color="gray.700"
            fontSize={16}
          >
            Country
          </Heading>
          <Box height="300px" width="160px">
            {isLoading ? (
                 <Flex justifyContent={'center'} alignItems={'center'} flexDirection={'column'} gap={6} height={'100%'}>
                 <span class="loader"></span>
                 <Text color="colorPalette.600">Loading...</Text>
               </Flex>
            ) : (
              <Doughnut data={countryData} options={options} />
            )}
          </Box>
        </CardBody>
      </Card>

      <Card
        width={{ base: "100%", md: "300px" }}
        boxShadow="lg"
        border="1px solid #ccc"
        borderRadius="4px"
        padding={"8px"}
      >
        <CardBody>
          <Heading
            size="md"
            mb={4}
            textAlign="center"
            color="gray.700"
            fontSize={16}
          >
            Devices
          </Heading>
          <Box height="300px" width="160px">
            {isLoading ? (
              <Flex justifyContent={'center'} alignItems={'center'} flexDirection={'column'} gap={6} height={'100%'}>
                <span class="loader"></span>
                <Text color="colorPalette.600">Loading...</Text>
              </Flex>
            ) : (
              <Doughnut data={deviceData} options={options} />
            )}
          </Box>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default DonutCharts;
